import { AsyncRenderer } from '../../components/AsyncRenderer/AsyncRenderer';

import { useChallengeDetailsVM } from './view-model/ChallengeDetails.viewModel';
import { Loader } from '../promotions/view/components/Loader';
import { ChallengeView } from './view/ChallengeDetails.view';
// TODO: [j,g]: move Loader to @design-system

type RouteParams = {
  influencerId: string;
  programId: string;
  challengeId: string;
};

export const ChallengeDetailsPage = (p: { params: RouteParams }) => {
  const vm = useChallengeDetailsVM({
    programId: parseInt(p.params.programId || '0', 10),
    challengeId: p.params.challengeId,
  });

  return (
    <AsyncRenderer
      data={vm}
      loadRender={<Loader />}
      renderer={(data) => <ChallengeView {...data} />}
    />
  );
};
